import { render } from "./LinkedPropertiesTab.vue?vue&type=template&id=d9e7a382&scoped=true"
import script from "./LinkedPropertiesTab.vue?vue&type=script&lang=js"
export * from "./LinkedPropertiesTab.vue?vue&type=script&lang=js"

import "./LinkedPropertiesTab.vue?vue&type=style&index=0&id=d9e7a382&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9e7a382"]])

export default __exports__